import React from 'react'

interface FootIconProps {
  className?: string
  size?: number
}

const FootIcon: React.FC<FootIconProps> = ({ className = '', size = 24 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Foot silhouette */}
      <path
        d="M8.5 3C7.5 3 6.8 3.8 6.8 4.8C6.8 5.2 6.9 5.6 7.1 5.9L7.5 6.5C7.6 6.7 7.7 6.9 7.7 7.1C7.7 7.4 7.5 7.6 7.2 7.6C6.9 7.6 6.7 7.4 6.7 7.1L6.5 6.2C6.3 5.4 5.6 4.8 4.8 4.8C3.8 4.8 3 5.6 3 6.6C3 7.2 3.3 7.7 3.8 8L4.5 8.5C4.8 8.7 5 9.1 5 9.5V11C5 12.1 5.9 13 7 13H8C8.6 13 9 13.4 9 14V16C9 17.7 10.3 19 12 19C13.7 19 15 17.7 15 16V14C15 13.4 15.4 13 16 13H17C18.1 13 19 12.1 19 11V9.5C19 9.1 19.2 8.7 19.5 8.5L20.2 8C20.7 7.7 21 7.2 21 6.6C21 5.6 20.2 4.8 19.2 4.8C18.4 4.8 17.7 5.4 17.5 6.2L17.3 7.1C17.3 7.4 17.1 7.6 16.8 7.6C16.5 7.6 16.3 7.4 16.3 7.1C16.3 6.9 16.4 6.7 16.5 6.5L16.9 5.9C17.1 5.6 17.2 5.2 17.2 4.8C17.2 3.8 16.5 3 15.5 3C14.5 3 13.8 3.8 13.8 4.8V5.5C13.8 6.3 13.2 7 12.4 7H11.6C10.8 7 10.2 6.3 10.2 5.5V4.8C10.2 3.8 9.5 3 8.5 3Z"
        fill="currentColor"
      />
      {/* Toes */}
      <circle cx="8" cy="20" r="1.5" fill="currentColor" />
      <circle cx="10.5" cy="21" r="1.2" fill="currentColor" />
      <circle cx="13" cy="21" r="1" fill="currentColor" />
      <circle cx="15.5" cy="20.5" r="0.8" fill="currentColor" />
      <circle cx="17.5" cy="19.5" r="0.7" fill="currentColor" />
    </svg>
  )
}

export default FootIcon 